import React, { Component } from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { stopImmediatePropagation } from '../../../../services/stop-immediate-propagation/index.tsx';
import messages from './messages.tsx';

type Props = {
	errorMessage: string;
	onRetry: () => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
export class Error extends Component<Props> {
	static defaultProps = { onRetry: noop };

	onClick = stopImmediatePropagation(() => this.props.onRetry());

	render() {
		const {
			errorMessage,
			intl: { formatMessage },
		} = this.props;
		return (
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			<ErrorMessageParentContainer data-test-id="navigation-apps.common.compontents.switcher.switcher.menu-list.error.retry">
				<ErrorMessageContainer>{errorMessage}</ErrorMessageContainer>
				<Button onClick={this.onClick}>{formatMessage(messages.retry)}</Button>
			</ErrorMessageParentContainer>
		);
	}
}

export default injectIntl(Error);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorMessageParentContainer = styled.div({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorMessageContainer = styled.span({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text'),
	font: token('font.heading.xxsmall'),
	marginBottom: token('space.100'),
	wordWrap: 'break-word',
	width: '100%',
	textAlign: 'center',
});
